module.exports = __webpack_public_path__ + "img/bg-top.c40adb24.jpg";